/*
 * Copyright ish group pty ltd 2021.
 *
 * This program is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General Public License version 3 as published by the Free Software Foundation.
 *
 *  This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more details.
 */
import { Amount } from '@api';
import React, { useEffect } from 'react';
import { Dispatch } from 'redux';
import { getCheckoutModelFromBackend } from 'src/js/enrol/actions/Actions';
import {
  checkoutResetPaymentSession,
  resetPaymentState,
  setPaymentFetching
} from 'src/js/enrol/containers/payment/actions/Actions';

interface Props {
  amount: Amount;
  disabled?: boolean;
  iframeUrl: string;
  checkoutCompleteWindcaveCcPayment: (sessionId: string) => void;
  dispatch: Dispatch<any>;
}

const WindcavePaymentComp = (
  {
    amount,
    dispatch,
    disabled,
    iframeUrl,
    checkoutCompleteWindcaveCcPayment
  }: Props) => {

  const proceedPayment = () => {
    dispatch(resetPaymentState());
    dispatch(getCheckoutModelFromBackend());
    dispatch(checkoutResetPaymentSession());
  };

  const onMessage = e => {
    const paymentDetails = e.data.payment;
    if (paymentDetails && paymentDetails.status) {
      dispatch(setPaymentFetching(true));
      checkoutCompleteWindcaveCcPayment(paymentDetails.sessionId);
    }
  };

  useEffect(() => {
    window.addEventListener("message", onMessage);
    return () => {
      window.removeEventListener("message", onMessage);
    };
  }, []);

  useEffect(() => {

    if (amount.payNow > 0) {
      proceedPayment();
    }
  }, [
    amount.payNow
  ]);

  return iframeUrl ? <iframe src={iframeUrl} frameBorder={0} height="575" width="100%" style={
      disabled ? {
        opacity: 0.6,
        pointerEvents: 'none',
      } : null}/> : null
};

export default WindcavePaymentComp;